module.exports = __webpack_public_path__ + "9575c6741b94b15ee0bec04499117c46.mp3";